import { RootState } from '@/store'
import { getUsers } from '@/store/selectors'
import { mapToUser } from '@/utilities/UserUtilities'

export const getAuditOffset = (state: RootState) => {
  return state.organizationAuditPage.offset || 0
}
export const getAuditTotalCount = (state: RootState) => {
  return state.organizationAuditPage.auditTotalCount || 0
}
export const getEvents = (state: RootState) => {
  return state.organizationAuditPage.events || []
}
export const getLogs = (state: RootState) => {
  return (state.organizationAuditPage && state.organizationAuditPage.audit) || []
}

export const getSearchedUsersInOrg = (state: RootState) => {
  const searchedUsers = state.organizationAuditPage.searchedUsers
  if (searchedUsers) {
    const users = getUsers(state)
    return searchedUsers.map(user => {
      return mapToUser(users.byId[user])
    })
  }
}
